import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navigation />
      
      <section className="py-16 px-6 sm:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Privacy Policy</h1>
          
          <div className="bg-white rounded-2xl border-2 border-slate-200 shadow-sm p-8 space-y-6 text-slate-700">
            <p className="text-sm text-slate-500">Last updated: December 2025</p>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Introduction</h2>
              <p>
                At Learn with Zeenat, we are committed to protecting your privacy. This Privacy Policy explains how we collect, 
                use, disclose, and safeguard your information when you use our educational platform.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Information We Collect</h2>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Personal Information</h3>
              <p className="mb-4">
                When you register for an account, we collect:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Name and email address (via Google OAuth)</li>
                <li>Profile picture (if provided through Google)</li>
                <li>Subscription tier and payment information</li>
                <li>Usage data (AI generations, resources downloaded)</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">How We Use Your Information</h2>
              <p className="mb-4">We use your information to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Provide and maintain our educational services</li>
                <li>Process your subscription and payments</li>
                <li>Generate AI-powered teaching resources</li>
                <li>Send you updates, newsletters, and teaching tips</li>
                <li>Improve our platform and user experience</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Data Security</h2>
              <p>
                We implement appropriate technical and organizational security measures to protect your personal information. 
                However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Third-Party Services</h2>
              <p className="mb-4">We use the following third-party services:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Google OAuth for authentication</li>
                <li>Emergent AI for AI generation services</li>
                <li>Cloud storage for file hosting</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Your Rights</h2>
              <p className="mb-4">You have the right to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Withdraw consent for data processing</li>
                <li>Export your data</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at:{' '}
                <a href="mailto:admin@learnwithzeenat.com" className="text-blue-600 hover:underline">
                  admin@learnwithzeenat.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
